import { Snapshot, TracksSnapshot, SNAPSHOT } from 'components/app/_mediator/memory/memory.slice';
import { useAudioTrackContext } from 'components/app/audio-track/_mediator/audio-track.provider';
import { useZoomContext } from './lib/zoom.provider';

const SRC = 'use-zoom-cb.ts';
const VIEW_OFFSET_RIGHT = 55;
const SCROLL_OFFSET_RIGHT = 77;

export const useZoomCb = () => {
  const { zoom, setZoom, handleZoom, trackElements, listenWheel, handleWheelListener, handleScroll } = useZoomContext();
  const { ws, wsWave, wsGetCursorTime, wsGetDuration, wsGetCursorPosition } = useAudioTrackContext();

  const zoomTo = (value: number) => {
    setZoom(value, 'value');
    handleZoom();
  };

  const scrollTo = (snapshot: Snapshot) => {
    handleScroll(snapshot.audioPosition);
    trackElements.current.forEach((el, i) => (el[0].scrollLeft = snapshot.trackPositions[i]));
  };

  const keepCursorInView = () => {
    const cursor = wsGetCursorTime('fraction');
    const cursorPosition = wsGetCursorPosition(cursor);
    const { scrollLeft, clientWidth } = wsWave.current!;
    if (cursorPosition <= 0) handleScroll(scrollLeft + cursorPosition);
    else {
      const outsidePos = cursorPosition + VIEW_OFFSET_RIGHT - clientWidth;
      if (outsidePos > 0) handleScroll(scrollLeft + outsidePos + SCROLL_OFFSET_RIGHT);
    }
  };

  const takeSnapshot = (): TracksSnapshot => {
    if (!ws.current || !wsWave.current) {
      console.error(`[${SRC}] useZoomCb: takeSnapshot`);
      return SNAPSHOT;
    }
    const currentTime = wsGetCursorTime();
    const duration = wsGetDuration();
    return {
      zoom: zoom.current,
      audioPosition: wsWave.current?.scrollLeft ?? 0,
      trackPositions: trackElements.current.map((el) => el[0].scrollLeft),
      /* NOTE: wsIssue: the currentTime may be longer than the duration if the player stops on its own (onFinish event) */
      cursorTime: currentTime > duration ? duration : currentTime,
    };
  };

  const restoreSnapshot = (snapshot: Snapshot) => {
    if (!wsWave.current) {
      console.error(`[${SRC}] useZoomCb: restoreSnapshot`);
      return;
    }
    listenWheel.current = true;
    zoomTo(snapshot.zoom);
    scrollTo(snapshot);
    handleWheelListener();
  };

  return { trackElements, zoomTo, takeSnapshot, restoreSnapshot, keepCursorInView };
};
